import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios';
import utils from '@/utils/utils';
import Home from '../views/home/Home'
import Globe from '../views/globe/Globe'
import SystemNoticePage from '../views/home/notice/SystemNoticePage'
import Login from '../views/user_system/Login'

import Article from '../views/create_page/article/Article'
import Video from '../views/create_page/video/Video'
import RetrievePassword from "@/views/user_system/charming_earth/RetrievePassword";
import Display3D from "@/components/image_details/three_dimensional_layer/ThreeDimensionalLayer";
import ProductDetail from "@/views/product_details/ProductDetails";
import ImageLayer from "@/components/image_details/image_layer/ImageLayer";
import CompareShare from "@/components/image_details/compare_layer/CompareShare";

import DocumentPage from '../views/document/documentPage'
import MobilePage from '../views/MobilePage'
import PictureVideoPreviewer from "@/components/picture_video_previewer/PictureVideoPreviewer";
import EarthLogin from "@/views/user_system/charming_earth/EarthLogin";
import RealNameAuth from "@/views/user_system/charming_earth/RealNameAuth";

import UserCenter from "@/views/user_system/UserCenter";

// 解决路由重复跳转错误
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return routerPush.call(this, location).catch(err => { })
};

Vue.use(VueRouter)

const routes = [
  {path: '/globe', name: 'globe', component: Globe, meta:{requireAuth:true}},
  {path: '/userCenter', name: 'userCenter', component: UserCenter, meta:{requireAuth:true}},
  {path: '/earthLogin', name: 'earthLogin', component: EarthLogin},
  {path: '/realNameAuth', name: 'realNameAuth', component: RealNameAuth, meta:{requireAuth:true}},
  {path: '/documentPage', name: 'documentPage', component: DocumentPage},


  {path: '/home', name: 'home', component: Home, meta:{requireAuth:true}},
  {path: '/systemNoticePage', name: 'systemNoticePage', component: SystemNoticePage, meta:{requireAuth:true}},
  {path: '/login', name: 'login', component: Login},
  {path: '/createArticle', name: 'createArticle', component: Article, meta:{requireAuth:true}},
  {path: '/createVideo', name: 'createVideo', component: Video, meta:{requireAuth:true}},
  {path: '/retrievePassword', name: 'retrievePassword', component: RetrievePassword},
  {path: '/productDetails', name: 'productDetails', component: ProductDetail},
  {path: '/3DLayer', name: '3DLayer', component: Display3D},


  {path: '/mobilePage', name: 'mobilePage', component: MobilePage},

  {path: '/compareShare', name: 'compareShare', component: CompareShare},
  {path: '/pictureVideoPreviewer', name: 'pictureVideoPreviewer', component: PictureVideoPreviewer},
  {path:"*",redirect:"/globe"},



]

const router = new VueRouter({
  mode: 'history',
  base: 'tools',
  routes
})


// 路由拦截：登录状态检查
router.beforeEach((to, from, next) => {
  if(to.query.userToken){
    window.localStorage.setItem('authorToken',to.query.userToken.toString())
  }
  let token = window.localStorage.getItem('authorToken')
  if(to.query.inviteCode){
    window.localStorage.setItem('inviteCode',to.query.inviteCode)
  }
  if (to.query.shareFileCode) {
    window.localStorage.setItem('shareFileCode', to.query.shareFileCode)
  }
  if (to.meta.requireAuth) {
    if (token) {
      //有token，调用接口判断是否超时
      axios({
        method:"get",
        url:"/authorApi/personal-data/getPersonalData",
      }).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.status === 200){
          //登录有效
          if(to.path === "/realNameAuth"){
            //实名认证页面，直接进入
            next();
          }
          else{
            //非实名认证页面，判断是否已进行实名认证
            if(resultData.data.cardStatus === 1){
              // 已经进行实名认证
              next();
            }
            else{
              //没有进行实名认证
              router.push({
                name: 'realNameAuth',
              })
            }
          }

        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });
    } else {
      //防止通过url进入，回到登录
      utils.quitLogin();
    }
  } else {
    next()
  }

})

// //路由跳转后 验证页面设备，小屏幕时不允许使用
// router.afterEach((to,from)=>{
//   if(window.innerWidth < 1200){
//     router.push({
//       name: 'mobilePage',
//     })
//   }
// })



export default router
